import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTwitter,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import whiteLogo from "../assets/logo/vidyalaya logo white logo.png";
const Footer = () => {
  return (
    <footer className="bg-blue-600 text-white py-8 mt-20">
      <div className="container px-4 mx-auto ">
        {/* Main content of the footer */}
        <div className="flex gap-10 flex-col justify-between items-start ">
          {/* Logo and Slogan */}
          <div className="mb-6 md:mb-0  md:text-left max-w-md text-start">
            <a href="#home">
              <img
                src={whiteLogo}
                alt="white logo"
                width={200}
                height={200}
                className="mb-2 cursor-pointer"
              />
            </a>
            <p className="text-sm">
              WE OFFER HIGH QUALITY EDUCATION FOR ALL STUDENTS WHO SEEK
              EXCELLENCE IN NEET/JEE/CUET AND CA/CMA/ACCA FOUNDATIONS.
            </p>
            <p className="text-sm pt-5 font-semibold">
              Calicut Beach, kozhikode 672332, Kerala 
            </p>
          </div>

          {/* Links to sections */}
          <div className="mb-6 md:mb-0">
            <ul className="flex flex-col max-md:flex-row gap-5 items-end md:flex-row justify-center md:justify-start space-y-2 md:space-y-0 md:space-x-6">
              <li>
                <a href="#home" className="hover:underline">
                  Home
                </a>
              </li>
              <li>
                <a href="#courses" className="hover:underline">
                  Our Courses
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:underline">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="#map" className="hover:underline">
                  Location
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media Links */}
          <div className="flex justify-center md:justify-end space-x-6 mb-6 md:mb-0">
            <a
              href="#"
              className="hover:text-gray-300"
            >
              <FontAwesomeIcon icon={faFacebook} size="2x" />
            </a>
            <a href="#" className="hover:text-gray-300">
              <FontAwesomeIcon icon={faTwitter} size="2x" />
            </a>
            <a
              href="#"
              className="hover:text-gray-300"
            >
              <FontAwesomeIcon icon={faInstagram} size="2x" />
            </a>
            <a
              href="#"
              className="hover:text-gray-300"
            >
              <FontAwesomeIcon icon={faLinkedin} size="2x" />
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center text-sm mt-8 border-t border-white pt-4">
          <p>
            &copy; {new Date().getFullYear()} Vidyalaya Institute. All Rights
            Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
